// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3XLWX","title":"AfterFrontImage_title__3yt6N"};